import politicsHolding from "@/assets/news/politics-holding.jpg";
import cryptoHolding from "@/assets/news/crypto-holding.jpg";
import techHolding from "@/assets/news/tech-holding.jpg";
import financialHolding from "@/assets/news/financial-holding.jpg";
import cultureHolding from "@/assets/news/culture-holding.jpg";
import regulationHolding from "@/assets/news/regulation-holding.jpg";
import industryHolding from "@/assets/news/industry-holding.jpg";
import generalHolding from "@/assets/news/general-holding.jpg";

const categoryImages: Record<string, string> = {
  Politics: politicsHolding,
  Crypto: cryptoHolding,
  "Tech & AI": techHolding,
  Financial: financialHolding,
  Culture: cultureHolding,
  Regulation: regulationHolding,
  Industry: industryHolding,
  General: generalHolding,
};

/** Returns the holding image for a given category, falling back to the general image */
export function getCategoryImage(category: string): string {
  return categoryImages[category] || generalHolding;
}
